import * as amazonInventoryMonthly from "./amazonInventoryMonthly";
import * as approvalFacade from "./approvalFacade";
import * as approvalFacadeImpl from "./approvalFacadeImpl";
import * as batchFacadeImpl from "./batchFacadeImpl";
import * as batchMaster from "./batchMaster";
import * as ebsFacadeImpl from "./ebsFacadeImpl";
import * as fulfilmentFacadeImpl from "./fulfilmentFacadeImpl";
import * as inPlanFacadeImpl from "./inPlanFacadeImpl";
import * as inPlanMaster from "./inPlanMaster";
import * as lendMaster from "./lendMaster";
import * as logisticsReturnRecord from "./logisticsReturnRecord";
import * as logisticsReturnRecordFacadeImpl from "./logisticsReturnRecordFacadeImpl";
import * as logisticsReverseFacadeImpl from "./logisticsReverseFacadeImpl";
import * as outPlanFacadeImpl from "./outPlanFacadeImpl";
import * as outPlanMaster from "./outPlanMaster";
import * as platformAccountPeriod from "./platformAccountPeriod";
import * as stockAdjustmentFacadeImpl from "./stockAdjustmentFacadeImpl";
import * as stockAdjustmentMaster from "./stockAdjustmentMaster";
import * as stockSkuPlatform from "./stockSkuPlatform";
import * as storageDamageMaster from "./storageDamageMaster";
import * as test from "./test";
import * as transfer from "./transfer";
import * as warehouseCost from "./warehouseCost";
import * as warehouseFacadeImpl from "./warehouseFacadeImpl";
import * as warehouseMaster from "./warehouseMaster";
import * as warehouseOrganize from "./warehouseOrganize";
import * as warehouseRules from "./warehouseRules";

export const fulfilment = {
  amazonInventoryMonthly,
  approvalFacade,
  approvalFacadeImpl,
  batchFacadeImpl,
  batchMaster,
  ebsFacadeImpl,
  fulfilmentFacadeImpl,
  inPlanFacadeImpl,
  inPlanMaster,
  lendMaster,
  logisticsReturnRecord,
  logisticsReturnRecordFacadeImpl,
  logisticsReverseFacadeImpl,
  outPlanFacadeImpl,
  outPlanMaster,
  platformAccountPeriod,
  stockAdjustmentFacadeImpl,
  stockAdjustmentMaster,
  stockSkuPlatform,
  storageDamageMaster,
  test,
  transfer,
  warehouseCost,
  warehouseFacadeImpl,
  warehouseMaster,
  warehouseOrganize,
  warehouseRules,
};
